// extracted by mini-css-extract-plugin
export var btn = "backToTop-module--btn--8C7Rt";
export var text = "backToTop-module--text--nY357";